import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class ContentViewService extends BaseService {
	constructor() {
		super('/contentView');
	}

	public getAllByFilter(filter: ContentViewFilter) {
		return super.getAllByFilterBase(filter);
	}

	//public deleteCache(id: number) {
	//	return this.deleteBase(`${this._resourceName}/deleteCache/${id}`);
	//}

}

export class ContentViewFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted?: boolean | null, contentTypeIdentifier?: string | null) {
		super();
		this._idTenant = idTenant;
		this._isDeleted = isDeleted;
		this._contentTypeIdentifier = contentTypeIdentifier;
	}

	private _idTenant?: number | null;
	private _isDeleted?: boolean | null;
	private _contentTypeIdentifier?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._contentTypeIdentifier != null ? { ContentTypeIdentifier: this._contentTypeIdentifier } : {})
		);

		return data;
	};
}